import Validation from "../../components/credits/validation";
/**
 * ValidationPage
 *
 * صفحه‌ای برای نمایش کامپوننت اعتبارسنجی.
 *
 * @returns JSX.Element
 */

const ValidationPage = () => {
  return <Validation />;
};

export default ValidationPage;
